import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  EventEmitter,
  Output,
  ElementRef,
  forwardRef,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormGroup,
  FormControl,
  Validators,
  FormArray,
  FormBuilder,
  ValidatorFn,
  ValidationErrors,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Subscription } from "rxjs";
//mport { UserInfoService } from './../services/user-info.service';
import { IUser } from "./../../models/user.model";
import { UserInfoService } from "./../../services/user-info.service";
import { ZpDataService } from "../../services/zp-data.service";
import { NotificationType } from "../../models/notification-type.enum";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { v4 as uuid } from "uuid";
import { GetInfoAndPassService } from "src/app/services/get-info-and-pass.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
  selector: "app-request-access-plan",
  templateUrl: "./request-access-plan.component.html",
  styleUrls: ["./request-access-plan.component.scss"],
})
export class RequestAccessPlanComponent implements OnInit, OnDestroy {
  public requestAccessFormGroup: FormGroup = new FormGroup({});
  public subscription: Subscription;
  public subscription1: Subscription;
  public myUser: IUser;
  public submitted = false;
  public sharedPlanClientId: any;
  public sharedPlan: any;
  public choiceReport = ["Death", "Incapacity"];

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private userInfoService: UserInfoService,
    private network: ZpDataService,
    private activatedRoute: ActivatedRoute,
    private getInfoAndPassService: GetInfoAndPassService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.sharedPlanClientId = params.get("Id");
    });
  }

  ngOnInit() {
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
    this.subscription1 =
      this.getInfoAndPassService.accessRightSection.subscribe((data) => {
        this.sharedPlan = data;
      });
    this.requestAccessFormGroup = this.formBuilder.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      email: ["", [Validators.email, Validators.required]],
      choiceReport: ["", [Validators.required]],
      relationToOwner: ["", [Validators.required]],
      phoneNumber: ["", [Validators.required]],
      fileDelegateId: [""],
      sharedPlanClientId: [""],
    });
  }

  get f() {
    return this.requestAccessFormGroup.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.requestAccessFormGroup.invalid) {
      return false;
    } else {
      this.requestAccessFormGroup.value["fileDelegateId"] =
        this.sharedPlan.delegateId;
      this.requestAccessFormGroup.value["sharedPlanClientId"] =
        this.sharedPlanClientId;
      let res = await this.network.requestAccess(
        this.requestAccessFormGroup.value
      );
      if (res) {
        this.network.alertMessage({
          message: "Request received",
          additionalInfo:
            "One of our team will contact you shortly regarding your request.",
          type: NotificationType.Success,
        });
        this.getInfoAndPassService.getInfoAndPass(this.sharedPlan);
        this.router.navigate(["/request-access"]);
      } else {
        this.network.alertMessage({
          message: "Failed",
          additionalInfo:
            "Please contact the administration. Something failed and your request was not submitted.",
          type: NotificationType.Warning,
        });
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
